import { useQuery } from 'react-query';
import { API_CTX } from '@/config';
import { restoreURL } from '@/lib/axios';

import { APIResponse } from '@/types';

import { AI_QUERY_KEY, AIModuleEntity } from '../types';

/**
 * Need to declare returned promise type, or cause ts complaint!
 * @returns ai list
 */
const getAIModules = (): Promise<APIResponse<AIModuleEntity>> => {
  return restoreURL().get(`${API_CTX}/ai-modules`);
};

export const useAIModules = () => {
  return useQuery<APIResponse<AIModuleEntity>, Error>(
    AI_QUERY_KEY,
    getAIModules
  );
};
